function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    transform: "scale(.8)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.73,75.58l13.12-.28,6.66-.11c2.23,0,4.46,0,6.7,0h.44v.45l.06,11.19v.5h-.5L74,87.21c-4.42,0-8.83-.11-13.24-.16h-.28v-.27c0-1.9.09-3.78.13-5.65Zm0,0,.14,5.66c0,1.86.11,3.7.13,5.53l-.27-.27c4.41,0,8.82-.16,13.24-.16l13.24-.07-.5.5.05-11.19.45.45C85,76,82.85,76,80.66,76l-6.58-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5,61.47l13.12-.28,6.66-.11c2.23,0,4.47,0,6.7,0h.44v.45l.06,11.19v.5H102L88.74,73.1c-4.42,0-8.83-.11-13.24-.16h-.28v-.27c0-1.9.09-3.78.13-5.65Zm0,0,.14,5.66c0,1.86.11,3.7.13,5.53l-.27-.27c4.41,0,8.82-.16,13.24-.16L102,72.16l-.5.5,0-11.19.45.45c-2.18,0-4.36,0-6.55-.06l-6.58-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.18,205.24,114.3,205l6.66-.11c2.23,0,4.47,0,6.7-.06h.44v.45l.06,11.19v.5h-.5l-13.24-.07c-4.42,0-8.83-.11-13.24-.16h-.28v-.27c0-1.9.09-3.79.13-5.66Zm0,0,.14,5.65c0,1.86.11,3.71.13,5.54l-.27-.28c4.41-.05,8.82-.15,13.24-.16l13.24-.06-.5.5,0-11.19.45.44c-2.19,0-4.36,0-6.55-.05l-6.58-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,191.13l13.12-.28,6.66-.11c2.23-.05,4.47,0,6.7-.06h.44v.45l.06,11.19v.5h-.5l-13.24-.07c-4.42,0-8.83-.11-13.24-.16h-.28v-.27c0-1.9.09-3.79.14-5.66Zm0,0,.14,5.65c0,1.86.11,3.71.13,5.54L116,202c4.41,0,8.82-.15,13.24-.16l13.24-.06-.5.5,0-11.19.45.44c-2.18,0-4.36,0-6.55,0l-6.58-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,61.47l13.13-.28,6.66-.11c2.22,0,4.46,0,6.69,0h.45v.45l.05,11.19v.5h-.51L59.19,73.1c-4.41,0-8.82-.11-13.24-.16h-.27v-.27c0-1.9.09-3.78.13-5.65Zm0,0,.15,5.66c0,1.86.11,3.7.13,5.53L46,72.39c4.42,0,8.83-.16,13.24-.16l13.24-.07-.5.5L72,61.47l.44.45c-2.18,0-4.35,0-6.54-.06l-6.58-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.27,304.5l-13.12.27-6.66.12c-2.23,0-4.46,0-6.7.05h-.44v-.44l-.06-11.19v-.51h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.89-.09,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.19,0,4.36,0,6.55.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.05,318.61l-13.13.27-6.66.12c-2.23,0-4.46,0-6.69.05h-.45v-.44l-.05-11.19v-.51h.51l13.24.06c4.41,0,8.82.11,13.24.16h.27v.27c0,1.89-.09,3.78-.13,5.65Zm0,0L453.9,313c0-1.86-.11-3.7-.13-5.53l.28.27c-4.42.05-8.83.16-13.24.16l-13.24.06.5-.49L428,318.61l-.44-.45c2.18,0,4.35,0,6.54,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.43,318.61l-13.12.27-6.66.12c-2.23,0-4.47,0-6.7.05h-.44v-.44l-.06-11.19v-.51H61l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.89-.09,3.78-.14,5.65Zm0,0L87.29,313c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16L61,307.91l.5-.49-.05,11.19-.45-.45c2.18,0,4.36,0,6.55,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.68,61.47l13.13-.28,6.66-.11c2.22,0,4.46,0,6.69,0h.45v.45l.05,11.19v.5h-.5l-13.24-.06c-4.41,0-8.83-.11-13.24-.16h-.27v-.27c0-1.9.08-3.78.13-5.65Zm0,0,.14,5.66c.05,1.86.12,3.7.13,5.53l-.27-.27c4.41,0,8.83-.16,13.24-.16l13.24-.07-.5.5.06-11.19.44.45c-2.18,0-4.36,0-6.54-.06L426,61.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.5,187.61H79.86V101H206.5Zm-125.64-1H205.5V102H80.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.76,106.55A2.52,2.52,0,1,1,87.24,104,2.52,2.52,0,0,1,89.76,106.55Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.06,106.55A2.53,2.53,0,1,1,97.53,104,2.52,2.52,0,0,1,100.06,106.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.35,106.55a2.52,2.52,0,1,1-2.52-2.52A2.52,2.52,0,0,1,110.35,106.55Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.36,
    y: 110.99,
    width: 125.64,
    height: 1,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.52,
    y: 91.4,
    width: 42.27,
    height: 42.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.32,89.2v46.67H449V89.2Zm44.47,44.48H404.52V91.4h42.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.97,
    y: 101.71,
    width: 14.61,
    height: 32.95,
    transform: "translate(545.45 -309.09) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.21,
    y: 104.1,
    width: 16.88,
    height: 16.88,
    transform: "translate(538.19 -313.11) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.99,
    y: 89.2,
    width: 1.8,
    height: 46.67,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.52,
    y: 151.43,
    width: 42.27,
    height: 42.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.78,
    y: 158.19,
    width: 11.04,
    height: 31.89,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.32,149.23V195.9H449V149.23Zm44.47,44.47H404.52V151.43h42.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.21,
    y: 164.12,
    width: 16.88,
    height: 16.88,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.99,
    y: 149.23,
    width: 1.8,
    height: 46.67,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.52,
    y: 211.45,
    width: 42.27,
    height: 42.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.21,
    y: 217.21,
    width: 23.2,
    height: 13.87,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.32,209.25v46.67H449V209.25Zm44.47,44.47H404.52V211.45h42.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.21,
    y: 224.15,
    width: 16.88,
    height: 16.88,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.99,
    y: 209.25,
    width: 1.8,
    height: 46.67,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.25,
    y: 253.53,
    width: 94.21,
    height: 140.38,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.69,
    y: 248.69,
    width: 103.34,
    height: 4.84,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.03,
    y: 248.69,
    width: 32.5,
    height: 4.84,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.47,
    y: 253.53,
    width: 31.92,
    height: 140.38,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.33,313.88H57.39v-41.8h73.94Zm-73.69-.25h73.44v-41.3H57.64Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.04,
    y: 284.31,
    width: 14.39,
    height: 8.27,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.81,292.08H88.17V284.8h14.64Zm-14.39-.25h14.14v-6.78H88.42Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.33,366.37H57.39v-41.8h73.94Zm-73.69-.25h73.44v-41.3H57.64Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.04,
    y: 336.79,
    width: 14.39,
    height: 8.27,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.81,344.57H88.17v-7.28h14.64Zm-14.39-.25h14.14v-6.78H88.42Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-33"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 420.81,
    rx: 194.85,
    ry: 25.28,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.32,304c-3.09-3-7.08-6.69-11.81-5.39-4.44,1.23-6.14,6.09-6.94,10.13-1,5.21-1.82,10.47-2.65,15.71s-1.62,10.61-2.38,15.92c-.43,3-.86,6-1.28,9-.21,1.5-.41,3-.62,4.5s-.45,2.94-.53,4.42c0,.47.71.54.82.09.57-2.5.81-5.1,1.17-7.63l1.11-7.66q1.13-7.59,2.28-15.19t2.36-15.19c.68-4.29,1-9.62,4.81-12.45a7.33,7.33,0,0,1,7.11-.67,21.05,21.05,0,0,1,6.46,4.52C113.3,304.19,113.38,304.09,113.32,304Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.09,300.94s-6.31-2.27-9.43,2.34.61,16.34,29.37,23a81.12,81.12,0,0,0-6.92-26C116,286.78,105,291.87,109.09,300.94Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.38,324.31a24.43,24.43,0,0,0-1.45-2.33c-.48-.74-1-1.48-1.46-2.21-.37-.56-.74-1.1-1.12-1.65,0-.13,0-.27.05-.41s.07-.5.1-.75c.07-.54.15-1.08.23-1.61s.17-1.08.27-1.61a8,8,0,0,1,.38-1.69c0-.09-.12-.13-.13,0a5.36,5.36,0,0,1-.26,1l-.19.73c-.14.54-.27,1.09-.39,1.64s-.21,1-.3,1.53c0,.24-.08.49-.11.74-.51-.74-1-1.46-1.58-2.17-1.52-2-3.14-3.95-4.81-5.84,0,0,0,0,0-.05a52.11,52.11,0,0,1,.75-9c0-.08-.1-.12-.12,0a30.88,30.88,0,0,0-1.08,8.6c-.59-.67-1.2-1.34-1.81-2-1.41-1.5-2.83-3-4.29-4.44a.06.06,0,0,0-.09.09c2.42,2.61,4.72,5.33,7,8.09a51.08,51.08,0,0,0-5.25.2c-2,.14-3.89.39-5.83.66-.08,0-.06.14,0,.13a53.81,53.81,0,0,1,5.81-.52c1.88-.08,3.74,0,5.62,0q1.82,2.25,3.59,4.54h-1.59c-.87,0-1.75.07-2.62.15a39.54,39.54,0,0,0-5.31.79.07.07,0,0,0,0,.13c1.77-.2,3.54-.37,5.32-.43.85,0,1.7,0,2.54,0h1.33a1.56,1.56,0,0,0,.72-.06c.78,1,1.55,2,2.32,3q.91,1.2,1.8,2.43c.61.83,1.15,1.75,1.82,2.53A.07.07,0,0,0,127.38,324.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.85,307.47a19.8,19.8,0,0,0-3.08-.14c-1,0-2,0-3.08.06a.07.07,0,1,0,0,.13c1-.07,2.08-.09,3.12-.08s2,.11,3,.09A0,0,0,0,0,111.85,307.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.87,309.79c.12-1,.24-2,.45-2.93,0-.09-.11-.12-.12,0-.15,1-.34,1.93-.48,2.9-.07.48-.14,1-.2,1.45a7.84,7.84,0,0,0-.12,1.37.09.09,0,0,0,.17,0,7.76,7.76,0,0,0,.15-1.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,298.91c-.25.95-.5,1.92-.68,2.9-.09.49-.16,1-.23,1.48a6,6,0,0,0-.09,1.46s.06,0,.07,0a8,8,0,0,0,.23-1.38c.06-.48.14-1,.22-1.43.17-1,.35-2,.6-3C119.12,298.87,119,298.83,119,298.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.53,357.25c-.16-1.81-.34-3.62-.53-5.43q-.57-5.37-1.3-10.73c-.48-3.56-.93-7.13-1.51-10.68a26.69,26.69,0,0,0-1.09-4.84,4.61,4.61,0,0,0-2.69-3c-3.38-1.17-5.66,2.34-7,4.82a.06.06,0,1,0,.11.06c.82-1.17,3.08-4.47,5.65-4.32,1.73.1,3.11,1.33,3.94,5.64,2.06,10.73,3.93,32.51,4.14,33.93.12.76.65.73.66-.08C81.89,360.8,81.68,359,81.53,357.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.29,326s3-10.45-3.58-5.23c-10.88,8.7-11.27,27.61-11.27,27.61s19.35-11.24,21.75-18.65C78.78,318.72,68.29,326,68.29,326Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,331.15c-1.51.31-3,.51-4.59.73l-2.18.31c-.49.07-1,.11-1.48.17,1.45-2,2.9-4,4.28-6,0-.08-.07-.16-.13-.1A44.29,44.29,0,0,0,64.62,330c-.28-.81-.57-1.61-.86-2.42s-.68-1.87-.92-2.83a.06.06,0,1,0-.12,0c.26.95.45,1.93.7,2.89s.53,1.84.86,2.74c-.71.92-1.39,1.87-2.05,2.82-.33-.94-.75-1.86-1-2.82,0-.08-.15,0-.12,0,.35,1.06.53,2.16.86,3.23-.45.65-.89,1.3-1.31,1.95-.79,1.21-1.52,2.44-2.24,3.68a.26.26,0,0,0-.17.29c-1.22,2.11-2.39,4.26-3.53,6.43,0,.07.07.13.11.06,1.15-2.14,2.43-4.22,3.75-6.27h0a2.51,2.51,0,0,1,.63-.12l.67-.15c.5-.11,1-.23,1.49-.36,1-.24,1.95-.47,2.95-.65.08,0,0-.13,0-.12-1.17.22-2.34.36-3.53.49-.56.07-1.11.14-1.67.23H59c.7-1.06,1.4-2.11,2.12-3.14s1.42-2,2.15-3c.67-.09,1.33-.27,2-.39l2.25-.44c1.49-.3,3-.63,4.49-.88C72.07,331.26,72,331.14,72,331.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.33,332.18l-.27-.83a17.22,17.22,0,0,1-.44-1.75c0-.08-.14,0-.12,0,.12.59.26,1.18.4,1.76a11.54,11.54,0,0,0,.5,1.74.12.12,0,0,0,.22-.07C60.54,332.77,60.42,332.48,60.33,332.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.93,328.74c-.88.13-1.77.19-2.66.27s-1.77.2-2.66.33c0,0,0,.08,0,.08.89-.06,1.77-.13,2.66-.25s1.77-.24,2.66-.3C74,328.86,74,328.72,73.93,328.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.77,344c-.35-7.69-.84-15.36-1.61-23-.38-3.82-.81-7.63-1.35-11.43a82.76,82.76,0,0,0-2.2-11.05,21.4,21.4,0,0,0-3.69-7.8,8.33,8.33,0,0,0-7.43-3.24c-3.37.41-6.08,2.53-8.42,4.84-2.63,2.58-5,5.4-7.47,8.17-.62.7-1.23,1.4-1.84,2.11,0,.06,0,.15.1.09,2.38-2.74,4.85-5.39,7.44-7.94,2.39-2.34,4.86-4.91,8.17-5.88a8.35,8.35,0,0,1,4.75-.11,7.45,7.45,0,0,1,3.24,2.05,16.9,16.9,0,0,1,3.66,7.11c2.07,7.07,2.81,14.48,3.58,21.78S94,334.56,94.38,342s.66,15,1.38,22.45c.09.92.21,1.84.33,2.76.08.62,1,.62,1,0C96.47,359.47,96.11,351.75,95.77,344Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.65,293.15s4.39-8.13-.8-10.73-22.56,16.77-27.63,45.12c0,0,28.05-12.41,37.57-24.77S78.52,287.68,70.65,293.15Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.77,299.76c-3.15,0-6.3-.24-9.45-.22l1.78-2a30.4,30.4,0,0,0,2.46-2.86c0-.06,0-.16-.11-.11a22.57,22.57,0,0,0-2.39,2.4c-.79.83-1.57,1.68-2.36,2.52-1.2,1.31-2.38,2.63-3.56,4,0-.13,0-.26,0-.38,0-.55,0-1.11,0-1.66l0-3.21c0-2.16,0-4.34.17-6.51,0-.08-.13-.07-.13,0-.15,2.17-.38,4.34-.48,6.51-.06,1.07-.08,2.14-.1,3.21,0,.56,0,1.11,0,1.66,0,.3,0,.62,0,.93-.19.21-.38.41-.56.62-2.52,2.87-4.91,5.85-7.24,8.87a4,4,0,0,0,0-.5c0-.33-.07-.67-.11-1-.08-.72-.18-1.44-.29-2.16s-.21-1.36-.32-2-.31-1.53-.37-2.29a.07.07,0,1,0-.13,0,22.06,22.06,0,0,1,.27,2.31c.06.69.13,1.38.19,2.08s.12,1.39.2,2.08c0,.33.06.67.1,1a4.26,4.26,0,0,0,.06.5,1,1,0,0,0,.13.4l-1.2,1.56c-1.59,2.11-3.15,4.24-4.71,6.36,0,.07,0,.16.09.09,1.48-1.93,3-3.82,4.55-5.7,1.15.05,2.33,0,3.48-.05s2.43,0,3.65,0a.07.07,0,0,0,0-.13c-1.22,0-2.44,0-3.65,0s-2.24,0-3.35,0c1.35-1.65,2.73-3.28,4.1-4.92.5-.59,1-1.19,1.51-1.78a6.54,6.54,0,0,0,1.4,0h1.66c1,0,2.08,0,3.11,0,2.14,0,4.28-.11,6.43-.11.08,0,.08-.13,0-.13-2.14,0-4.29-.12-6.43-.17l-3.11-.08-1.66,0c-.31,0-.64,0-1,0L61,304.62a.14.14,0,0,0,.06-.07c1.15-1.36,2.3-2.72,3.46-4.06l.48-.55c3.27.1,6.54-.11,9.8-.05A.07.07,0,0,0,74.77,299.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.16,305.33h-.77c-.07,0-.07.12,0,.12h.76A.07.07,0,0,0,73.16,305.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.46,305.34q-1.51,0-3-.06l-1.51,0a6,6,0,0,0-1.41,0c-.05,0,0,.08,0,.09a5.52,5.52,0,0,0,1.41.1l1.51,0c1,0,2,0,3,0A.07.07,0,0,0,71.46,305.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.64,314.81a41.54,41.54,0,0,0-6.2-.56s0,0,0,.05c2.06.19,4.12.3,6.17.64C62.69,315,62.72,314.82,62.64,314.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.21,305.79l-.06-.55c-.06-.4-.12-.81-.19-1.21-.12-.77-.25-1.54-.4-2.3,0-.08-.13-.06-.12,0,.09.79.18,1.58.25,2.38,0,.39.07.78.1,1.17a3.18,3.18,0,0,0,.16,1.11c.06.12.24.07.27,0A1.61,1.61,0,0,0,54.21,305.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.49,282.71c-1-1.87-2.28-4.33-4.79-4.18-2.07.13-3,2.24-3.44,4-1.37,5.4-1.47,11.09-1.73,16.62-.56,11.69-1.07,23.4-1.14,35.1,0,3.25,0,6.49,0,9.74s0,6.64.23,9.94a.25.25,0,0,0,.49,0c0-2.83-.09-5.67-.1-8.5s0-5.52.06-8.28q.14-8.4.45-16.78c.2-5.56.45-11.12.68-16.68l.36-8.33c.12-2.69.24-5.38.55-8.06.17-1.49.39-3,.7-4.47a6.33,6.33,0,0,1,1.3-3,2.81,2.81,0,0,1,3.65-.26,7.69,7.69,0,0,1,2.6,3.23C95.42,282.85,95.53,282.79,95.49,282.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.81,281.82s-2.06-7.28,2.49-3.64c7.59,6.06,7.86,19.23,7.86,19.23s-13.48-7.83-15.16-13C87.51,276.73,94.81,281.82,94.81,281.82Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.32,292c-.12-.2-.26-.4-.38-.6a4.28,4.28,0,0,0,0-.62c0-.31,0-.62,0-.94,0-.61,0-1.22.07-1.84,0-.08-.13-.08-.13,0,0,.6-.06,1.2-.07,1.8,0,.31,0,.61,0,.91,0,.12,0,.25,0,.39-.53-.82-1.07-1.64-1.64-2.44-.16-.23-.33-.45-.5-.68a14.55,14.55,0,0,1,0-2.38c0-.85,0-1.69.05-2.54,0-.08-.12-.08-.13,0,0,.88-.06,1.75-.11,2.63a17,17,0,0,0,0,1.89c-1.3-1.77-2.68-3.48-4.08-5.18,0-.05-.15,0-.1.08.87,1.1,1.69,2.22,2.51,3.36-1.59-.37-3.2-.58-4.81-.82-.08,0-.12.12,0,.13,1.7.26,3.38.69,5.06,1.06h0c.65.91,1.29,1.83,1.92,2.74.26.37.51.75.77,1.13h-.08L100,290c-.37,0-.75-.08-1.12-.11-.78-.06-1.56-.1-2.33-.14-.09,0-.09.13,0,.13.77,0,1.53.07,2.29.16l1.2.14.53.07.16,0L102,292.2c.76,1.12,1.44,2.33,2.25,3.41a.06.06,0,0,0,.11-.06A34.71,34.71,0,0,0,102.32,292Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,283.79c0-.28,0-.56,0-.85a13.25,13.25,0,0,1,.07-1.78c0-.09-.13-.11-.13,0,0,.59-.06,1.17-.09,1.76,0,.3,0,.59,0,.89,0,.13,0,.27,0,.4a1.23,1.23,0,0,0,0,.43.06.06,0,0,0,.11,0,1.22,1.22,0,0,0,0-.38C99,284.09,99,283.94,99,283.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3,286.81c-.5-.09-1-.12-1.52-.16s-1.11-.09-1.67-.17c-.09,0-.11.13,0,.13,1.06.07,2.12.26,3.19.3C97.34,286.91,97.36,286.82,97.3,286.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.53,286.85a.67.67,0,0,1,0,.28v.24c0,.17,0,.34,0,.5v.51a1.12,1.12,0,0,0,0,.45,0,0,0,0,0,0,0,.39.39,0,0,0,0-.21v-1.49c0-.07,0-.22,0-.28S101.45,286.73,101.53,286.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8,321.54c-2.83-2.13-5.38-5.19-9.19-5.34-3.15-.12-5.35,2.24-6.61,4.88a26.8,26.8,0,0,0-1.55,4.35q-.86,3-1.6,6-1.48,5.93-2.53,12c-.38,2.24-.74,4.48-1,6.74a55.17,55.17,0,0,0-.66,6.9.36.36,0,0,0,.7.08c.38-1.89.55-3.84.82-5.74s.57-3.83.9-5.74q1-5.73,2.25-11.4c.82-3.56,1.62-7.18,2.77-10.66.82-2.49,2.14-5.39,4.83-6.29,4.09-1.36,7.81,2.1,10.8,4.35C95.78,321.68,95.87,321.59,95.8,321.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.87,319.5S90.26,312,94,310.58c5.66-2.2,20.48,14.5,17.58,40.08a146,146,0,0,1-19.91-13.41c-8.46-7.09-10.62-16.36-6.9-18.76S92.87,319.5,92.87,319.5Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.91,345.18a18.83,18.83,0,0,0-1.38-2.58c-.48-.88-1-1.75-1.48-2.61-1-1.69-2-3.37-3-5l-.49-.81.06-.3c0-.25.11-.49.17-.74.12-.56.22-1.12.32-1.68.21-1.09.4-2.2.69-3.27,0-.08-.11-.11-.12,0-.24,1.1-.58,2.17-.91,3.24-.16.53-.33,1.06-.46,1.59l-.15.55c-1.22-2-2.45-4-3.79-5.9a2.83,2.83,0,0,0,.13-.83c0-.37.09-.74.13-1.12.1-.84.2-1.68.32-2.52.25-1.65.49-3.28.9-4.9,0-.08-.11-.1-.13,0-.41,1.61-.85,3.22-1.16,4.85-.15.8-.29,1.61-.39,2.42-.06.4-.1.81-.14,1.21,0,.12,0,.24,0,.37-.41-.58-.82-1.16-1.25-1.73-1.31-1.72-2.67-3.4-4-5.07-.06-.07-.16,0-.11.07a90.39,90.39,0,0,1,6.44,9.41c.38.6.74,1.2,1.12,1.81l-.37-.05c-.48-.06-1-.09-1.45-.14l-2.89-.25c-1.93-.15-3.86-.27-5.79-.47-.08,0-.11.11,0,.12,2,.23,3.89.54,5.83.82l2.87.38a11.34,11.34,0,0,0,2.21.23l2.28,3.69c-.17,0-.35,0-.52,0h-2.75c-1.25,0-2.49,0-3.73,0-.09,0-.07.13,0,.13,1.26,0,2.52.08,3.77.15.6,0,1.2.06,1.79.11l.9.06a1.71,1.71,0,0,0,.78,0c.64,1.05,1.3,2.09,1.94,3.14s1.19,1.93,1.8,2.89a25.07,25.07,0,0,0,1.94,2.92C109.84,345.3,109.94,345.26,109.91,345.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.45,324.5a18.08,18.08,0,0,1-.51,2.43c-.21.83-.45,1.65-.72,2.47a.08.08,0,1,0,.15,0c.26-.8.48-1.61.68-2.44s.33-1.66.53-2.48C104.6,324.44,104.46,324.42,104.45,324.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,329.5a.94.94,0,0,0-.63-.23l-1.08-.15-2-.25c-1.4-.16-2.8-.29-4.19-.47-.08,0-.11.12,0,.13,1.31.16,2.62.36,3.94.53.64.08,1.29.18,1.93.25l.93.1a3.11,3.11,0,0,1,1.06.19A.06.06,0,0,0,96,329.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.43,340.75c-.66-.06-1.32-.08-2-.1l-1,0H101a3.33,3.33,0,0,1-.63,0c-.09,0-.1.14,0,.13a2.79,2.79,0,0,1,.58,0l.52,0,1,.06c.66,0,1.33.08,2,.08C104.51,340.89,104.51,340.76,104.43,340.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.47,337.89c.08-.38.15-.75.22-1.13.13-.74.27-1.47.4-2.21,0-.08-.11-.1-.13,0l-.48,2.15-.24,1.08c0,.17-.07.33-.1.5a1.38,1.38,0,0,0-.06.53c0,.06.1.11.14,0A2.52,2.52,0,0,0,108.47,337.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.69 354.17 70.49 363.24 73.2 393.86 97.18 393.86 100.56 363.24 101.56 354.17 69.69 354.17",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.69 354.17 70.49 363.24 100.56 363.24 101.56 354.17 69.69 354.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.31,
    y: 351.69,
    width: 36.62,
    height: 7.36,
    transform: "translate(171.25 710.74) rotate(180)",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-33"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "15.56 393.86 74.17 393.61 132.78 393.52 250 393.36 367.22 393.52 425.83 393.61 484.44 393.86 425.83 394.1 367.22 394.19 250 394.36 132.78 394.19 74.17 394.1 15.56 393.86",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-33"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.84,
    y: 114.78,
    width: 374.31,
    height: 250.43,
    rx: 12.89,
    transform: "translate(490 -10) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.64,
    y: 79.04,
    width: 229.01,
    height: 322.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.05,
    y: 40.8,
    width: 3.89,
    height: 54.5,
    rx: 1.25,
    transform: "translate(318.04 -181.95) rotate(90)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 413.84,
    r: 7.05,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.64,
    y: 79.04,
    width: 229.01,
    height: 322.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.64,
    y: 79.04,
    width: 229.01,
    height: 7.87,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.75,83a2,2,0,1,1-1.95-2A2,2,0,0,1,141.75,83Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.72,83a2,2,0,1,1-1.95-2A2,2,0,0,1,149.72,83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.69,83a2,2,0,1,1-2-2A2,2,0,0,1,157.69,83Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.68,157.82a1.57,1.57,0,0,0,.81-.19,1.58,1.58,0,0,0,.52-.51,2.1,2.1,0,0,0,.29-.72,4.6,4.6,0,0,0,.08-.84V152h1.34v3.54a5.23,5.23,0,0,1-.17,1.34A3,3,0,0,1,162,158a2.56,2.56,0,0,1-.94.74,3.27,3.27,0,0,1-1.38.28,3.21,3.21,0,0,1-1.42-.29,2.74,2.74,0,0,1-.94-.77,2.87,2.87,0,0,1-.52-1.1,5,5,0,0,1-.16-1.3V152H158v3.54a3.89,3.89,0,0,0,.08.85,2.08,2.08,0,0,0,.28.72,1.59,1.59,0,0,0,.53.5A1.47,1.47,0,0,0,159.68,157.82Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.22,153.84a1.73,1.73,0,0,0-.25-.19l-.44-.23c-.17-.07-.36-.13-.56-.19a2.64,2.64,0,0,0-.62-.08,1.35,1.35,0,0,0-.83.21.69.69,0,0,0-.27.58.56.56,0,0,0,.1.35.84.84,0,0,0,.3.25,2.07,2.07,0,0,0,.49.2l.69.19a8.55,8.55,0,0,1,.93.29,2.36,2.36,0,0,1,.7.39,1.59,1.59,0,0,1,.44.56,1.8,1.8,0,0,1,.16.81,2,2,0,0,1-.21,1,1.79,1.79,0,0,1-.57.65,2.42,2.42,0,0,1-.82.35,3.85,3.85,0,0,1-1,.11,5.15,5.15,0,0,1-1.55-.23,4.85,4.85,0,0,1-1.37-.67l.6-1.16a1.48,1.48,0,0,0,.32.23,4.45,4.45,0,0,0,.54.28,3.5,3.5,0,0,0,.69.24,3,3,0,0,0,.79.1c.74,0,1.11-.24,1.11-.71a.55.55,0,0,0-.13-.38,1,1,0,0,0-.36-.28,2.75,2.75,0,0,0-.56-.21l-.75-.22a5.68,5.68,0,0,1-.86-.3,2.12,2.12,0,0,1-.61-.38,1.31,1.31,0,0,1-.37-.51,1.78,1.78,0,0,1-.12-.69,2.19,2.19,0,0,1,.19-.94,1.9,1.9,0,0,1,.54-.68,2.71,2.71,0,0,1,.81-.42,3.53,3.53,0,0,1,1-.14,3.9,3.9,0,0,1,1.35.23,5,5,0,0,1,1.08.54Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.9,157.78V159h-4.82V152h4.73v1.18h-3.38v1.68h2.92V156h-2.92v1.81Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,159V152H179a2,2,0,0,1,.89.2,2.28,2.28,0,0,1,.7.53,3,3,0,0,1,.46.74,2.35,2.35,0,0,1-.18,2.07,1.89,1.89,0,0,1-.91.79l1.58,2.62h-1.51l-1.42-2.33h-1.33V159Zm1.35-3.52H179a.85.85,0,0,0,.35-.08.92.92,0,0,0,.28-.24,1,1,0,0,0,.18-.36,1.27,1.27,0,0,0,.07-.44,1.12,1.12,0,0,0-.08-.45,1.07,1.07,0,0,0-.21-.36.83.83,0,0,0-.3-.23.76.76,0,0,0-.35-.09h-1.63Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.49,152h1.19l2.64,6.95h-1.39l-.64-1.74h-2.43l-.64,1.74h-1.39Zm1.55,4.27-1-2.73-1,2.73Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.65,158.18a2.63,2.63,0,0,1-1.93.84,3.11,3.11,0,0,1-1.29-.28,3.26,3.26,0,0,1-1.05-.75,3.71,3.71,0,0,1-.7-1.13,3.65,3.65,0,0,1-.26-1.41,3.37,3.37,0,0,1,.26-1.34,3.57,3.57,0,0,1,.71-1.11,3.69,3.69,0,0,1,1.07-.75,3.16,3.16,0,0,1,1.34-.28,3.27,3.27,0,0,1,1.68.41,2.61,2.61,0,0,1,1.05,1.11l-1,.74a2,2,0,0,0-.74-.79,2.07,2.07,0,0,0-1-.28,1.79,1.79,0,0,0-.81.19,1.73,1.73,0,0,0-.63.51,2.5,2.5,0,0,0-.4.74,2.91,2.91,0,0,0-.14.89,2.77,2.77,0,0,0,.15.92,2.38,2.38,0,0,0,.44.74,1.94,1.94,0,0,0,1.46.67,2.35,2.35,0,0,0,1.82-.95v-.49h-1.4v-1h2.52V159h-1.12Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.92,159V152H201a2,2,0,0,1,.88.2,2.28,2.28,0,0,1,.7.53,2.48,2.48,0,0,1,.46.74,2.29,2.29,0,0,1,.17.84,2.37,2.37,0,0,1-.34,1.23,1.91,1.91,0,0,1-.92.79l1.59,2.62H202l-1.42-2.33h-1.33V159Zm1.35-3.52H201a.77.77,0,0,0,.34-.08.92.92,0,0,0,.28-.24,1.23,1.23,0,0,0,.19-.36,1.56,1.56,0,0,0,.07-.44,1.33,1.33,0,0,0-.08-.45,1.07,1.07,0,0,0-.21-.36.87.87,0,0,0-.31-.23.72.72,0,0,0-.34-.09h-1.64Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.25,157.78V159h-4.82V152h4.74v1.18h-3.39v1.68h2.92V156h-2.92v1.81Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.13,157.78V159h-4.82V152h4.74v1.18h-3.39v1.68h2.92V156h-2.92v1.81Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.85,159v-4.6l-1.79,3.42h-.73l-1.79-3.42V159h-1.35V152h1.45l2.05,3.95,2.08-3.95h1.43V159Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.48,157.78V159h-4.83V152h4.74v1.18H226v1.68h2.93V156H226v1.81Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.88,154.51V159h-1.35V152h1.05l3.62,4.56V152h1.35V159h-1.1Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.19,153.2H241V159h-1.34V153.2h-2.22V152h5.78Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.53,369.45v-6.94h2.53a3.85,3.85,0,0,1,1.49.27,3,3,0,0,1,1.07.75,2.88,2.88,0,0,1,.64,1.1,3.92,3.92,0,0,1,.22,1.34,4,4,0,0,1-.24,1.43,3,3,0,0,1-1.77,1.8,3.73,3.73,0,0,1-1.41.25Zm4.59-3.48a3,3,0,0,0-.14-.92,2,2,0,0,0-.4-.72,1.63,1.63,0,0,0-.65-.47,2.21,2.21,0,0,0-.87-.17h-1.18v4.58h1.18a2.07,2.07,0,0,0,.88-.18,1.72,1.72,0,0,0,.65-.48,2.22,2.22,0,0,0,.39-.73A2.94,2.94,0,0,0,183.12,366Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.36,368.27v1.18h-4.82v-6.94h4.73v1.18h-3.38v1.67h2.92v1.1h-2.92v1.81Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.85,365.93a3.73,3.73,0,0,1,.23-1.26,3.51,3.51,0,0,1,.67-1.11,3.36,3.36,0,0,1,1.08-.79,3.31,3.31,0,0,1,1.44-.3,3.15,3.15,0,0,1,1.66.42,2.59,2.59,0,0,1,1,1.09l-1,.72a1.83,1.83,0,0,0-.34-.5,1.75,1.75,0,0,0-.42-.31,1.56,1.56,0,0,0-.47-.17,2,2,0,0,0-.48-.06,1.79,1.79,0,0,0-.88.21,1.9,1.9,0,0,0-.63.53,2.45,2.45,0,0,0-.37.74,2.71,2.71,0,0,0,0,1.72,2.14,2.14,0,0,0,.41.74,2,2,0,0,0,.65.52,1.74,1.74,0,0,0,.82.2,2.12,2.12,0,0,0,.49-.06,1.84,1.84,0,0,0,.49-.19,1.8,1.8,0,0,0,.42-.32,1.66,1.66,0,0,0,.32-.49l1.1.64a2.17,2.17,0,0,1-.47.69,2.88,2.88,0,0,1-.7.5,3.88,3.88,0,0,1-.82.32,3.75,3.75,0,0,1-.87.1,3,3,0,0,1-1.36-.31,3.55,3.55,0,0,1-1.06-.82,3.86,3.86,0,0,1-.69-1.14A3.5,3.5,0,0,1,190.85,365.93Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,369.45v-6.94h1.35v5.76h3.54v1.18Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.7,369.45v-6.94h1.35v6.94Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.84,365v4.45h-1.35v-6.94h1l3.62,4.56v-4.55h1.35v6.93h-1.09Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.78,368.27v1.18H214v-6.94h4.73v1.18h-3.38v1.67h2.92v1.1h-2.92v1.81Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 168.53,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 174.03,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 179.54,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 185.04,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 190.55,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 196.05,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 201.56,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 207.06,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 212.57,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 218.07,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 223.58,
    width: 116.38,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 234.58,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 240.09,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 245.59,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 251.1,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 256.6,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 262.11,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 267.61,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 273.12,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 278.62,
    width: 116.38,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 289.63,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 295.14,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 300.64,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 306.14,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 311.65,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 317.15,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 322.66,
    width: 188.32,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.02,
    y: 328.16,
    width: 116.38,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.51,379.26h-86.1V353.53h86.1Zm-85.1-1h84.1V354.53h-84.1Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.28,
    y: 354.03,
    width: 85.09,
    height: 24.73,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.75,382.05H255.91V350.74h91.84Zm-90.84-1h89.84V351.74H256.91Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.74,362.51h1.2l2.64,6.94h-1.39l-.65-1.73h-2.42l-.64,1.73h-1.39Zm1.56,4.26-1-2.73-1,2.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.67,365.93a3.5,3.5,0,0,1,.23-1.26,3.33,3.33,0,0,1,.67-1.11,3.43,3.43,0,0,1,1.07-.79,3.39,3.39,0,0,1,1.45-.3,3.17,3.17,0,0,1,1.66.42,2.65,2.65,0,0,1,1,1.09l-1,.72a2.09,2.09,0,0,0-.34-.5,1.75,1.75,0,0,0-.42-.31,1.66,1.66,0,0,0-.47-.17,2,2,0,0,0-.48-.06,1.76,1.76,0,0,0-.88.21,1.9,1.9,0,0,0-.63.53,2.73,2.73,0,0,0-.38.74,3,3,0,0,0-.12.83,3,3,0,0,0,.14.89,2.34,2.34,0,0,0,.42.74,1.94,1.94,0,0,0,.65.52,1.74,1.74,0,0,0,.82.2,2.12,2.12,0,0,0,.49-.06,1.84,1.84,0,0,0,.49-.19,1.8,1.8,0,0,0,.42-.32,1.46,1.46,0,0,0,.31-.49l1.11.64a2.17,2.17,0,0,1-.47.69,2.88,2.88,0,0,1-.7.5,3.76,3.76,0,0,1-.83.32,3.67,3.67,0,0,1-.86.1,3,3,0,0,1-1.36-.31,3.55,3.55,0,0,1-1.06-.82,3.77,3.77,0,0,1-.94-2.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.31,365.93a3.73,3.73,0,0,1,.23-1.26,3.51,3.51,0,0,1,.67-1.11,3.32,3.32,0,0,1,2.53-1.09,3.14,3.14,0,0,1,1.65.42,2.68,2.68,0,0,1,1.05,1.09l-1,.72a1.81,1.81,0,0,0-.33-.5,1.75,1.75,0,0,0-.42-.31,1.66,1.66,0,0,0-.47-.17,2.1,2.1,0,0,0-.48-.06,1.8,1.8,0,0,0-.89.21,1.9,1.9,0,0,0-.63.53,2.45,2.45,0,0,0-.37.74,2.71,2.71,0,0,0,0,1.72,2.31,2.31,0,0,0,.41.74,2,2,0,0,0,.65.52,1.78,1.78,0,0,0,.83.2,2,2,0,0,0,.48-.06,1.72,1.72,0,0,0,.49-.19,1.85,1.85,0,0,0,.43-.32,1.64,1.64,0,0,0,.31-.49l1.1.64a2.17,2.17,0,0,1-.47.69,3,3,0,0,1-.69.5,4,4,0,0,1-.83.32,3.73,3.73,0,0,1-.86.1,2.93,2.93,0,0,1-1.36-.31,3.43,3.43,0,0,1-1.06-.82,3.69,3.69,0,0,1-.7-1.14A3.5,3.5,0,0,1,296.31,365.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.27,368.27v1.18h-4.83v-6.94h4.74v1.18h-3.39v1.67h2.93v1.1h-2.93v1.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.32,369.45v-6.94h2.95a1.87,1.87,0,0,1,.88.2,2.16,2.16,0,0,1,.7.53,2.36,2.36,0,0,1,.46.74,2.29,2.29,0,0,1,.17.84,2.25,2.25,0,0,1-.16.85,2.2,2.2,0,0,1-.44.74,2.16,2.16,0,0,1-.68.52,2,2,0,0,1-.88.2h-1.65v2.32Zm1.35-3.51h1.57a.78.78,0,0,0,.62-.3,1.24,1.24,0,0,0,.25-.82,1.42,1.42,0,0,0-.08-.48,1.25,1.25,0,0,0-.2-.36,1.05,1.05,0,0,0-.3-.22,1.09,1.09,0,0,0-.35-.07h-1.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.61,363.69h-2.22v5.76h-1.34v-5.76h-2.22v-1.18h5.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.54,
    y: 86.91,
    width: 7.11,
    height: 314.28,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.09,312.85h0a1.84,1.84,0,0,1-1.84-1.84V90.18a1.84,1.84,0,0,1,1.84-1.84h0a1.84,1.84,0,0,1,1.84,1.84V311A1.85,1.85,0,0,1,361.09,312.85Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.75,459c2.16.69,63.68-.1,66-1.62.89-.57,1.29-9.54,1.47-20.39,0-.12,0-.23,0-.34,0-2.24.07-4.54.07-6.88,0-.32,0-.64,0-1l-3-31.92-41.16.41,4.06,31.62.05,1.25.25,6.55,0,.67s-23.41,10.84-25.79,12.78S325.59,458.31,327.75,459Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.75,459c2.16.69,63.68-.1,66-1.62.89-.57,1.29-9.54,1.47-20.39,0-.12,0-.23,0-.34,0-2.24.07-4.54.07-6.88,0-.32,0-.64,0-1l-40.08.11.05,1.25.25,6.55,0,.67s-23.41,10.84-25.79,12.78S325.59,458.31,327.75,459Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.74,459c1.11.36,17.83.32,34.17,0,3.28-.06,6.55-.14,9.67-.22,11.65-.32,21.28-.8,22.17-1.39s1.29-9.28,1.47-19.93c0-.15,0-.3,0-.45s0-.24,0-.35h-.05l-39.65.07,0,.68s-23.42,10.83-25.79,12.77S325.59,458.31,327.74,459Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.42,456.6c10.36-.39,52.22-1,62.5-.58.08,0,.08.06,0,.07-10.27.61-52.13.86-62.5.68C328.2,456.77,328.2,456.61,328.42,456.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.12,436.89c4.07-.82,9.07-.25,12.23,2.61.12.11,0,.29-.17.25a57.38,57.38,0,0,0-12-2.35A.26.26,0,0,1,351.12,436.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.2,438.7c4.07-.81,9.07-.25,12.22,2.62.13.11,0,.28-.17.24a57.15,57.15,0,0,0-12-2.34A.26.26,0,0,1,348.2,438.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.27,440.52c4.08-.82,9.08-.26,12.23,2.61.12.11,0,.28-.17.24a57.79,57.79,0,0,0-12-2.34A.26.26,0,0,1,345.27,440.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.91,459c3.28-.06,6.55-.14,9.67-.22,11.65-.32,21.28-.8,22.17-1.39s1.29-9.28,1.47-19.93c0-.15,0-.3,0-.45s0-.24,0-.35h-.05C389.76,440.45,370.62,453.19,361.91,459Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.84,436.86h44.31s-8.92-103.5-8.58-105.31c.45-2.31,3.06-12.79,6.55-26.47,1.09-4.29,2.26-8.88,3.49-13.64,3.3-12.88,6.94-26.95,10.12-39.19,4.76-18.35,8.48-32.6,8.48-32.6H379.65s-4.38,13.88-9.89,31.93c-9,29.34-21,69.71-22.18,79.53C345.66,347,352.84,436.86,352.84,436.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.8,429.29c6.77-.14,4.82-.19,11.59-.26,3.31,0,25.08-.22,28.17.29.07,0,.07.13,0,.14-3.09.51-24.86.33-28.17.29-6.77-.06-4.82-.12-11.59-.26A.1.1,0,0,1,354.8,429.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.24,325.23c1.45-6.41,3.62-12.69,5.51-19q5.76-19.17,11.59-38.31,2.91-9.57,5.85-19.14,1.49-4.81,3-9.65c1-3.14,2.11-6.26,3-9.43.37-1.3.56-.59.1,1.05-.94,3.31-1.86,6.62-2.82,9.91q-2.86,9.8-5.76,19.58-5.76,19.47-11.63,38.92-2.93,9.75-5.86,19.5a78.47,78.47,0,0,0-2.4,9.43,43.69,43.69,0,0,0-.39,10.09c.42,6.78,1.21,13.55,1.84,20.31s1.25,13.56,1.88,20.34q1.88,20.24,3.71,40.47c.15,1.71.3,3.42.44,5.13,0,.57-.83.53-.89,0-1.46-13.34-2.58-26.72-3.83-40.08s-2.49-26.59-3.73-39.88c-.31-3.34-.67-6.68-.67-10A41.4,41.4,0,0,1,380.24,325.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.92,219.65c2.6,20.17,7.57,58,11.2,85.43,8.47-33.25,22.09-85.43,22.09-85.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.69,459.59c2.16.7,63.69.13,66-1.38.9-.56,1.34-9.53,1.56-20.38v-.34c.05-2.24.09-4.54.1-6.88,0-.32,0-.64,0-1,.15-15.67-1-31.92-1-31.92l-40.22.26,1.12,31.62,0,1.26.22,6.54,0,.68s-23.45,10.75-25.84,12.68S372.53,458.89,374.69,459.59Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.69,459.59c2.16.7,63.69.13,66-1.38.9-.56,1.34-9.53,1.56-20.38v-.34c.05-2.24.09-4.54.1-6.88,0-.32,0-.64,0-1l-40.08,0,0,1.26.22,6.54,0,.68s-23.45,10.75-25.84,12.68S372.53,458.89,374.69,459.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.69,459.59c2.16.7,63.69.13,66-1.38.9-.56,1.34-9.53,1.56-20.38v-.34l-39.7-.08,0,.68s-23.45,10.75-25.84,12.68S372.53,458.89,374.69,459.59Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.37,457.2c10.36-.35,52.22-.79,62.5-.35.08,0,.08.06,0,.06-10.27.58-52.13.67-62.5.46C375.15,457.36,375.15,457.2,375.37,457.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.14,437.57c4.08-.8,9.07-.22,12.22,2.66.12.11,0,.28-.17.24a57.88,57.88,0,0,0-12-2.39A.26.26,0,0,1,398.14,437.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.21,439.37c4.08-.8,9.07-.22,12.22,2.66.12.11,0,.28-.17.24a57.22,57.22,0,0,0-12-2.38A.26.26,0,0,1,395.21,439.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.28,441.17c4.08-.8,9.08-.22,12.22,2.66.12.11,0,.28-.17.24a57.22,57.22,0,0,0-12-2.38A.26.26,0,0,1,392.28,441.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.87,219.65s.86,18,5,32.2c.33,1.18.69,2.34,1.08,3.45a66.58,66.58,0,0,1,10.82,5.56s.43,14.46.87,30.58c.48,18,1,38.13.87,42.39-.37,15.95,2,103.67,2,103.67l44.3.18s-8-98-7.95-103.8c.08-9.4-2.15-50.91-3.87-81.19-1-18.66-1.92-33-1.92-33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,429.62c6.76-.11,4.82-.17,11.59-.21,3.31,0,25.08-.11,28.17.41a.07.07,0,0,1,0,.14c-3.1.5-24.86.22-28.17.17-6.77-.09-4.83-.14-11.59-.31A.1.1,0,0,1,403,429.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.32,226.07c.81,24.72,1.68,49.44,2.78,74.15s2.6,49.57,4.68,74.3c1.16,13.81,2.25,33.25,3.74,47,0,.1-.13.13-.14,0-3.23-24.52-5-54.84-6.61-79.51s-2.66-49.39-3.5-74.09c-.48-14-.84-28-1.26-41.93C428,225.86,428.31,225.88,428.32,226.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.08,254.23a82,82,0,0,1,12.66,6.63.15.15,0,0,1-.13.26c-4.28-2.08-8.64-4.08-12.79-6.38A.29.29,0,0,1,385.08,254.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.83,239c.29,1.58.67,3.14,1,4.7s.56,3,.94,4.42a7.52,7.52,0,0,0,2.06,3.7c.58.54,1.21,1,1.83,1.5.33.27.69.52,1,.79l-.12-.64-.3-1.79c-.23-1.32-.44-2.65-.64-4-.4-2.61-.77-5.25-1.31-7.84a.08.08,0,1,1,.16,0c.65,2.56,1.37,5.1,1.93,7.68.28,1.27,1.27,7.53,1.32,8s.08.92.1,1.38a6,6,0,0,1,0,1.4c0,.12-.16.1-.21,0h0a5.76,5.76,0,0,1-.4-1.36c-.11-.45-.21-.9-.29-1.36,0-.16-.06-.33-.08-.5-.62-.37-1.19-.87-1.77-1.28s-1.25-.89-1.84-1.39a7.07,7.07,0,0,1-2.25-3.51,26.23,26.23,0,0,1-.73-4.5c-.2-1.78-.35-3.56-.6-5.34C384.65,238.92,384.81,238.87,384.83,239Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,178.94c-3.44,10.34-18.79,43.18-25.25,45.47-6.72,2.39-32.67,5.36-38.43.82-2.82-2.22-3.8-26,0-25.39s26.69,1.43,29.41.45,20.91-27.44,28.29-33.85C407.76,155.39,402.87,173.37,401,178.94Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.1,199.44l.38,29.58s26.61.07,33.7-3.66,22.09-37.92,25.84-51-2.25-15.11-11.78-5.51S367.38,198.57,365.68,199,343.1,199.44,343.1,199.44Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.25,165.76a1,1,0,1,0,1,1A1,1,0,0,0,402.25,165.76Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,0,1,0,1.38Zm-20.78,12.9a.9.9,0,0,0-.4.09l-.56.69a.93.93,0,0,0,0,.24,1,1,0,0,0,2,0A1,1,0,0,0,381.47,180.36Zm0,1.7a.69.69,0,1,1,.69-.68A.69.69,0,0,1,381.47,182.06Zm10.39-1.7a1,1,0,0,0-1,1,1,1,0,1,0,1-1Zm0,1.7a.69.69,0,1,1,.69-.68A.69.69,0,0,1,391.86,182.06Zm-4.7-8.82-.21.25a.67.67,0,0,1,.4.63.68.68,0,0,1-.68.69.68.68,0,0,1-.59-.33l-.21.24a1,1,0,1,0,1.29-1.48Zm9.89-.13a1,1,0,1,0,1,1A1,1,0,0,0,397.05,173.11Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,0,1,0,1.38Zm-26,20.16a1,1,0,0,0,0,2,1,1,0,1,0,0-2Zm0,1.69a.69.69,0,0,1,0-1.37.69.69,0,1,1,0,1.37ZM381.47,195a1,1,0,1,0,1,1A1,1,0,0,0,381.47,195Zm0,1.69a.69.69,0,0,1,0-1.37.69.69,0,1,1,0,1.37ZM391.86,195a1,1,0,1,0,1,1A1,1,0,0,0,391.86,195Zm0,1.69a.69.69,0,0,1,0-1.37.69.69,0,1,1,0,1.37Zm-15.58-8.95a1,1,0,0,0-1,1,1,1,0,0,0,2,0A1,1,0,0,0,376.28,187.71Zm0,1.7a.69.69,0,1,1,0-1.38.69.69,0,0,1,0,1.38Zm10.39-1.7a1,1,0,0,0-1,1,1,1,0,0,0,2,0A1,1,0,0,0,386.67,187.71Zm0,1.7a.69.69,0,1,1,0-1.38.69.69,0,0,1,0,1.38Zm10.38-1.7a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1.06,1.06,0,0,0,.4-.08h0l.53-1.31A1,1,0,0,0,397.05,187.71Zm0,1.7a.69.69,0,1,1,.69-.68A.69.69,0,0,1,397.05,189.41Zm-46.74,20.16a1,1,0,1,0,1,1A1,1,0,0,0,350.31,209.57Zm0,1.7a.69.69,0,1,1,0-1.38.69.69,0,0,1,0,1.38Zm10.39-1.7a1,1,0,1,0,1,1A1,1,0,0,0,360.7,209.57Zm0,1.7a.69.69,0,1,1,0-1.38.69.69,0,0,1,0,1.38Zm10.38-1.7a1,1,0,1,0,1,1A1,1,0,0,0,371.08,209.57Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,0,1,0,1.38Zm10.39-1.7a1,1,0,1,0,1,1A1,1,0,0,0,381.47,209.57Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,0,1,0,1.38Zm-36.36-9a1,1,0,0,0,0,2,1,1,0,1,0,0-2Zm0,1.69a.69.69,0,0,1,0-1.37.69.69,0,1,1,0,1.37Zm10.39-1.69a1,1,0,1,0,1,1A1,1,0,0,0,355.5,202.32Zm0,1.69a.69.69,0,0,1,0-1.37.69.69,0,1,1,0,1.37Zm10.39-1.69a1,1,0,1,0,1,1A1,1,0,0,0,365.89,202.32Zm0,1.69a.69.69,0,0,1,0-1.37.69.69,0,1,1,0,1.37Zm10.39-1.69a1,1,0,1,0,1,1A1,1,0,0,0,376.28,202.32Zm0,1.69a.69.69,0,1,1,0-1.37.69.69,0,0,1,0,1.37Zm10.39-1.69a1,1,0,1,0,1,1A1,1,0,0,0,386.67,202.32Zm0,1.69a.69.69,0,1,1,0-1.37.69.69,0,0,1,0,1.37Zm-36.36,20.16a1,1,0,0,0-1,1,1,1,0,0,0,2,0A1,1,0,0,0,350.31,224.17Zm0,1.7a.69.69,0,1,1,0-1.38.69.69,0,0,1,0,1.38Zm10.39-1.7a1,1,0,0,0-1,1,1,1,0,0,0,2,0A1,1,0,0,0,360.7,224.17Zm0,1.7a.69.69,0,1,1,0-1.38.69.69,0,0,1,0,1.38Zm10.38-1.7a1,1,0,0,0-1,1,1,1,0,0,0,2,0A1,1,0,0,0,371.08,224.17Zm0,1.7a.69.69,0,1,1,.69-.68A.69.69,0,0,1,371.08,225.87Zm-26-9a1,1,0,1,0,1,1A1,1,0,0,0,345.11,216.92Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,1,1,0,1.38Zm10.39-1.7a1,1,0,1,0,1,1A1,1,0,0,0,355.5,216.92Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,1,1,0,1.38Zm10.39-1.7a1,1,0,1,0,1,1A1,1,0,0,0,365.89,216.92Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,1,1,0,1.38Zm10.39-1.7a1,1,0,1,0,1,1A1,1,0,0,0,376.28,216.92Zm0,1.7a.69.69,0,1,1,0-1.38.69.69,0,0,1,0,1.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.86,214c0-2.34-.17-11.72-.39-14,0,0-.06,0-.07,0-.23,2.25-.35,11.51-.33,13.86a126.63,126.63,0,0,0,.52,14c0,.08.15.1.15,0C351.09,223.29,350.9,218.66,350.86,214Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,174.36c-3.75,13.09-18.75,47.27-25.84,51-3.4,1.79-11.28,2.71-18.57,3.17l41.78-65.63C404,162.5,405.31,166.37,403,174.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.66,246.35c-.16.16-65.08-4.29-65.62-5-.76-1,19.78-67,24.93-76.66,2.2-4.13,12.69-4.72,16.84-.82,10.39,9.77,17.62,41.36,19.14,50.83C434.48,230.32,437.24,245.78,436.66,246.35Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.25,165.76a1,1,0,1,0,1,1A1,1,0,0,0,402.25,165.76Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,0,1,0,1.38Zm10.39-1.7a1,1,0,1,0,1,1A1,1,0,0,0,412.64,165.76Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,0,1,0,1.38Zm-20.78,12.9a1,1,0,0,0-1,1,1,1,0,1,0,1-1Zm0,1.7a.69.69,0,1,1,.69-.68A.69.69,0,0,1,391.86,182.06Zm10.39-1.7a1,1,0,0,0-1,1,1,1,0,0,0,2,0A1,1,0,0,0,402.25,180.36Zm0,1.7a.69.69,0,1,1,0-1.38.69.69,0,0,1,0,1.38Zm10.39-1.7a1,1,0,0,0-1,1,1,1,0,0,0,2,0A1,1,0,0,0,412.64,180.36Zm0,1.7a.69.69,0,1,1,0-1.38.69.69,0,0,1,0,1.38Zm10.5,0H423a.69.69,0,0,1-.68-.68.73.73,0,0,1,.31-.59,2.49,2.49,0,0,0-.11-.29,1,1,0,0,0-.51.88,1,1,0,0,0,1,1,.85.85,0,0,0,.23,0A2.49,2.49,0,0,0,423.14,182.05Zm-26.09-8.94a1,1,0,1,0,1,1A1,1,0,0,0,397.05,173.11Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,0,1,0,1.38Zm10.39-1.7a1,1,0,1,0,1,1A1,1,0,0,0,407.44,173.11Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,0,1,0,1.38Zm10.39-1.7a1,1,0,1,0,1,1A1,1,0,0,0,417.83,173.11Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,0,1,0,1.38Zm-26,20.16a1,1,0,1,0,1,1A1,1,0,0,0,391.86,195Zm0,1.69a.69.69,0,0,1,0-1.37.69.69,0,1,1,0,1.37ZM402.25,195a1,1,0,1,0,1,1A1,1,0,0,0,402.25,195Zm0,1.69a.69.69,0,1,1,0-1.37.69.69,0,0,1,0,1.37ZM412.64,195a1,1,0,1,0,1,1A1,1,0,0,0,412.64,195Zm0,1.69a.69.69,0,1,1,0-1.37.69.69,0,0,1,0,1.37ZM423,195a1,1,0,0,0,0,2,1,1,0,1,0,0-2Zm0,1.69a.69.69,0,0,1,0-1.37.69.69,0,1,1,0,1.37Zm-35.73-8.72-.11.32a.7.7,0,0,1,.17.47.68.68,0,0,1-.55.67c0,.1-.07.21-.11.32a1,1,0,0,0,1-1A1,1,0,0,0,387.29,187.94Zm9.76-.23a1,1,0,0,0-1,1,1,1,0,0,0,2,0A1,1,0,0,0,397.05,187.71Zm0,1.7a.69.69,0,1,1,.69-.68A.69.69,0,0,1,397.05,189.41Zm10.39-1.7a1,1,0,0,0-1,1,1,1,0,0,0,2,0A1,1,0,0,0,407.44,187.71Zm0,1.7a.69.69,0,1,1,.69-.68A.69.69,0,0,1,407.44,189.41Zm10.39-1.7a1,1,0,0,0-1,1,1,1,0,1,0,1-1Zm0,1.7a.69.69,0,1,1,.69-.68A.69.69,0,0,1,417.83,189.41Zm-36.36,20.16a1,1,0,1,0,1,1A1,1,0,0,0,381.47,209.57Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,0,1,0,1.38Zm10.39-1.7a1,1,0,1,0,1,1A1,1,0,0,0,391.86,209.57Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,0,1,0,1.38Zm10.39-1.7a1,1,0,1,0,1,1A1,1,0,0,0,402.25,209.57Zm0,1.7a.69.69,0,1,1,0-1.38.69.69,0,0,1,0,1.38Zm10.39-1.7a1,1,0,1,0,1,1A1,1,0,0,0,412.64,209.57Zm0,1.7a.69.69,0,1,1,0-1.38.69.69,0,0,1,0,1.38Zm10.38-1.7a1,1,0,1,0,1,1A1,1,0,0,0,423,209.57Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,0,1,0,1.38Zm-36.35-9a1,1,0,1,0,1,1A1,1,0,0,0,386.67,202.32Zm0,1.69a.69.69,0,1,1,0-1.37.69.69,0,0,1,0,1.37Zm10.38-1.69a1,1,0,0,0,0,2,1,1,0,1,0,0-2Zm0,1.69a.69.69,0,0,1,0-1.37.69.69,0,1,1,0,1.37Zm10.39-1.69a1,1,0,1,0,1,1A1,1,0,0,0,407.44,202.32Zm0,1.69a.69.69,0,0,1,0-1.37.69.69,0,1,1,0,1.37Zm10.39-1.69a1,1,0,1,0,1,1A1,1,0,0,0,417.83,202.32Zm0,1.69a.69.69,0,0,1,0-1.37.69.69,0,1,1,0,1.37Zm10.39-1.69a1,1,0,1,0,1,1A1,1,0,0,0,428.22,202.32Zm0,1.69a.69.69,0,1,1,0-1.37.69.69,0,0,1,0,1.37Zm-46.75,20.16a1,1,0,0,0-1,1,1,1,0,0,0,2,0A1,1,0,0,0,381.47,224.17Zm0,1.7a.69.69,0,1,1,.69-.68A.69.69,0,0,1,381.47,225.87Zm10.39-1.7a1,1,0,0,0-1,1,1,1,0,1,0,1-1Zm0,1.7a.69.69,0,1,1,.69-.68A.69.69,0,0,1,391.86,225.87Zm10.39-1.7a1,1,0,0,0-1,1,1,1,0,0,0,2,0A1,1,0,0,0,402.25,224.17Zm0,1.7a.69.69,0,1,1,0-1.38.69.69,0,0,1,0,1.38Zm10.39-1.7a1,1,0,0,0-1,1,1,1,0,0,0,2,0A1,1,0,0,0,412.64,224.17Zm0,1.7a.69.69,0,1,1,0-1.38.69.69,0,0,1,0,1.38Zm10.38-1.7a1,1,0,0,0-1,1,1,1,0,0,0,2,0A1,1,0,0,0,423,224.17Zm0,1.7a.69.69,0,1,1,.69-.68A.69.69,0,0,1,423,225.87Zm10.75-.1a.72.72,0,0,1-.36.1.69.69,0,0,1,0-1.38h.15c0-.11,0-.21-.05-.32h-.1a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,.42-.09Zm-47.1-8.85a1,1,0,1,0,1,1A1,1,0,0,0,386.67,216.92Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,0,1,0,1.38Zm10.38-1.7a1,1,0,1,0,1,1A1,1,0,0,0,397.05,216.92Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,0,1,0,1.38Zm10.39-1.7a1,1,0,1,0,1,1A1,1,0,0,0,407.44,216.92Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,0,1,0,1.38Zm10.39-1.7a1,1,0,1,0,1,1A1,1,0,0,0,417.83,216.92Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,0,1,0,1.38Zm10.39-1.7a1,1,0,1,0,1,1A1,1,0,0,0,428.22,216.92Zm0,1.7a.69.69,0,1,1,0-1.38.69.69,0,0,1,0,1.38Zm-56.71,20.26c0,.1-.06.21-.08.31a.68.68,0,0,1,.34.6.7.7,0,0,1-.64.69c0,.12,0,.22-.05.31a1,1,0,0,0,1-1A1,1,0,0,0,371.51,238.88Zm10-.1a1,1,0,1,0,1,1A1,1,0,0,0,381.47,238.78Zm0,1.7a.7.7,0,0,1-.68-.69.69.69,0,1,1,1.37,0A.69.69,0,0,1,381.47,240.48Zm10.39-1.7a1,1,0,1,0,1,1A1,1,0,0,0,391.86,238.78Zm0,1.7a.7.7,0,0,1-.68-.69.69.69,0,1,1,1.37,0A.69.69,0,0,1,391.86,240.48Zm10.39-1.7a1,1,0,1,0,1,1A1,1,0,0,0,402.25,238.78Zm0,1.7a.7.7,0,0,1-.69-.69.69.69,0,0,1,.69-.69.67.67,0,0,1,.68.69A.68.68,0,0,1,402.25,240.48Zm10.39-1.7a1,1,0,1,0,1,1A1,1,0,0,0,412.64,238.78Zm0,1.7a.7.7,0,0,1-.69-.69.69.69,0,0,1,.69-.69.67.67,0,0,1,.68.69A.68.68,0,0,1,412.64,240.48Zm10.38-1.7a1,1,0,0,0,0,2,1,1,0,1,0,0-2Zm0,1.7a.7.7,0,0,1-.68-.69.69.69,0,1,1,1.37,0A.69.69,0,0,1,423,240.48Zm10.39-1.7a1,1,0,1,0,1,1A1,1,0,0,0,433.41,238.78Zm0,1.7a.7.7,0,0,1-.68-.69.69.69,0,1,1,1.37,0A.69.69,0,0,1,433.41,240.48Zm-57.13-9a1,1,0,0,0-1,1,1,1,0,0,0,2,0A1,1,0,0,0,376.28,231.52Zm0,1.7a.69.69,0,1,1,0-1.38.69.69,0,0,1,0,1.38Zm10.39-1.7a1,1,0,0,0-1,1,1,1,0,0,0,2,0A1,1,0,0,0,386.67,231.52Zm0,1.7a.69.69,0,1,1,0-1.38.69.69,0,0,1,0,1.38Zm10.38-1.7a1,1,0,0,0-1,1,1,1,0,0,0,2,0A1,1,0,0,0,397.05,231.52Zm0,1.7a.69.69,0,1,1,.69-.68A.69.69,0,0,1,397.05,233.22Zm10.39-1.7a1,1,0,0,0-1,1,1,1,0,0,0,2,0A1,1,0,0,0,407.44,231.52Zm0,1.7a.69.69,0,1,1,.69-.68A.69.69,0,0,1,407.44,233.22Zm10.39-1.7a1,1,0,0,0-1,1,1,1,0,1,0,1-1Zm0,1.7a.69.69,0,1,1,.69-.68A.69.69,0,0,1,417.83,233.22Zm10.39-1.7a1,1,0,0,0-1,1,1,1,0,0,0,2,0A1,1,0,0,0,428.22,231.52Zm0,1.7a.69.69,0,1,1,0-1.38.69.69,0,0,1,0,1.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.53,171.38c17.23,19,36.66,51.1,28.35,58-7.59,6.26-35.32.31-52.74-6.51-3.32-1.29,10.13-30.64,13.52-28.89a95.84,95.84,0,0,0,11,5c.95.26-4.29-6.14-10.12-21.52C405.64,161.73,411.68,160.5,421.53,171.38Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.3,191.74c0,3.41,8.4,2.74,8.4,2.74a6.25,6.25,0,0,0-2.56,3.43c-.64,2.51,3,4.61,3,4.61a7.75,7.75,0,0,0-2.12,4c-.37,2.47,3,5.11,3,5.11a6.78,6.78,0,0,0,.37,4.73c2,3.89,8.73,4,12.88,4.84a89.53,89.53,0,0,1,13.62,4.34L412.66,195s-18-10.7-23.05-10.46C385.37,184.7,368.33,186.53,368.3,191.74Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.77,194.38c4.45-1.29,9.21-1.52,13.81-1.69a.08.08,0,0,1,0,.16c-4.57.12-9.22,1.45-13.78,1.75C376.68,194.61,376.65,194.42,376.77,194.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.29,202.17a12.36,12.36,0,0,1,3.16-.17c1.12,0,2.24.05,3.36.1q3.36.15,6.72.48c.1,0,.11.16,0,.16-2.23-.1-4.47-.17-6.71-.17-1.12,0-2.24,0-3.36,0a14.5,14.5,0,0,1-3.16-.11A.16.16,0,0,1,377.29,202.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.16,211.68a8.58,8.58,0,0,1,2.86,0c1,.07,2,.14,3.06.19,2,.12,4.09.23,6.13.27a.08.08,0,0,1,0,.16c-2.07,0-4.15,0-6.23-.09q-1.53,0-3.06-.09a7.81,7.81,0,0,1-2.77-.33A.06.06,0,0,1,378.16,211.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.46,194.6l-6.64,33s41.27,10.76,45.55.32-20-49.21-34-60.27-8.74,6.37-8.32,7.76c1.89,6.19,10.69,22.34,10.69,22.34Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.64,165.76a1,1,0,1,0,1,1A1,1,0,0,0,412.64,165.76Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,0,1,0,1.38Zm0,12.9a1,1,0,0,0-.53.16c0,.1.09.19.13.29a.71.71,0,0,1,.4-.13.68.68,0,0,1,.68.7.67.67,0,0,1-.52.66c0,.09.09.18.13.28a1,1,0,0,0,.72-.94A1,1,0,0,0,412.64,180.36Zm10.38,0a1,1,0,0,0-1,1,1,1,0,0,0,2,0A1,1,0,0,0,423,180.36Zm0,1.7a.69.69,0,1,1,.69-.68A.69.69,0,0,1,423,182.06Zm-5.19-8.95a1,1,0,1,0,1,1A1,1,0,0,0,417.83,173.11Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,0,1,0,1.38Zm-4.5,20.43-.08.42a.79.79,0,0,1,.07.32.66.66,0,0,1-.24.52l-.09.41a1,1,0,0,0,.34-1.67ZM423,195a1,1,0,0,0,0,2,1,1,0,1,0,0-2Zm0,1.69a.69.69,0,0,1,0-1.37.69.69,0,1,1,0,1.37ZM433.41,195a1,1,0,1,0,1,1A1,1,0,0,0,433.41,195Zm0,1.69a.69.69,0,0,1,0-1.37.69.69,0,1,1,0,1.37Zm-15.58-8.95a1,1,0,0,0-1,1,1,1,0,1,0,1-1Zm0,1.7a.69.69,0,1,1,.69-.68A.69.69,0,0,1,417.83,189.41Zm10.39-1.7a1,1,0,0,0-1,1,1,1,0,0,0,2,0A1,1,0,0,0,428.22,187.71Zm0,1.7a.69.69,0,1,1,0-1.38.69.69,0,0,1,0,1.38Zm-15.58,20.16a1,1,0,1,0,1,1A1,1,0,0,0,412.64,209.57Zm0,1.7a.69.69,0,1,1,0-1.38.69.69,0,0,1,0,1.38Zm10.38-1.7a1,1,0,1,0,1,1A1,1,0,0,0,423,209.57Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,0,1,0,1.38Zm10.39-1.7a1,1,0,1,0,1,1A1,1,0,0,0,433.41,209.57Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,0,1,0,1.38Zm10.39-1.7a1,1,0,1,0,1,1A1,1,0,0,0,443.8,209.57Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,0,1,0,1.38Zm-26-9a1,1,0,1,0,1,1A1,1,0,0,0,417.83,202.32Zm0,1.69a.69.69,0,0,1,0-1.37.69.69,0,1,1,0,1.37Zm10.39-1.69a1,1,0,1,0,1,1A1,1,0,0,0,428.22,202.32Zm0,1.69a.69.69,0,1,1,0-1.37.69.69,0,0,1,0,1.37Zm10.39-1.69a1,1,0,1,0,1,1A1,1,0,0,0,438.61,202.32Zm0,1.69a.69.69,0,1,1,0-1.37.69.69,0,0,1,0,1.37Zm-26,20.16a1,1,0,0,0-1,1,1,1,0,0,0,2,0A1,1,0,0,0,412.64,224.17Zm0,1.7a.69.69,0,1,1,0-1.38.69.69,0,0,1,0,1.38Zm10.38-1.7a1,1,0,0,0-1,1,1,1,0,0,0,2,0A1,1,0,0,0,423,224.17Zm0,1.7a.69.69,0,1,1,.69-.68A.69.69,0,0,1,423,225.87Zm10.39-1.7a1,1,0,0,0-1,1,1,1,0,0,0,2,0A1,1,0,0,0,433.41,224.17Zm0,1.7a.69.69,0,1,1,.69-.68A.69.69,0,0,1,433.41,225.87Zm10.39-1.7a1,1,0,0,0-1,1,1,1,0,1,0,1-1Zm0,1.7a.69.69,0,1,1,.69-.68A.69.69,0,0,1,443.8,225.87Zm-26-9a1,1,0,1,0,1,1A1,1,0,0,0,417.83,216.92Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,0,1,0,1.38Zm10.39-1.7a1,1,0,1,0,1,1A1,1,0,0,0,428.22,216.92Zm0,1.7a.69.69,0,1,1,0-1.38.69.69,0,0,1,0,1.38Zm10.39-1.7a1,1,0,1,0,1,1A1,1,0,0,0,438.61,216.92Zm0,1.7a.69.69,0,1,1,0-1.38.69.69,0,0,1,0,1.38Zm10.38-1.7a1,1,0,1,0,1,1A1,1,0,0,0,449,216.92Zm0,1.7a.69.69,0,0,1,0-1.38.69.69,0,1,1,0,1.38Zm-20.77,12.9a1,1,0,0,0-.43.1l1.07.13A1,1,0,0,0,428.22,231.52Zm10.39,0a1,1,0,0,0-1,.92h.31a.69.69,0,0,1,.68-.6.67.67,0,0,1,.67.61h.33A1,1,0,0,0,438.61,231.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.18,194.63c4.74,1.67,17.16,7.86,19.88,10.4.08.08,0,.21-.09.14-2.69-1.89-18-9.4-20.44-10.32a2.92,2.92,0,0,1-.16.37c-.08.12-.15.05-.14-.06a6.27,6.27,0,0,1,.17-.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.71,213.07c.44-2.3,2.17-11.51,2.42-13.83,0,0-.06-.06-.07,0-.67,2.17-2.64,11.21-3.09,13.51a127.3,127.3,0,0,0-2.29,13.87c0,.08.12.12.14,0C416.09,222.19,416.83,217.61,417.71,213.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.1,197.91c-1.3-2.8-2.87-5.48-4.29-8.22s-2.89-5.45-4.21-8.23c0,0-.08,0-.07,0,.81,1.89,1.61,3.78,2.47,5.65-.26-.3-.51-.6-.75-.91-.43-.57-.84-1.15-1.23-1.75a0,0,0,0,0-.06,0,9.64,9.64,0,0,0,1.14,1.87,14.08,14.08,0,0,0,1.11,1.21c.35.76.71,1.51,1.09,2.26a58.23,58.23,0,0,0,4.32,8.06C420.68,198,421.14,198,421.1,197.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.79,232.21c-4.87-.06-23.25-3.67-27.81-4.6.06-.49,0-.65.13-1.34,0-.09-.13-.13-.15,0-.13.64-.56,1.93-.38,2,2.18.86,23.43,4.57,28.22,4.18A.11.11,0,0,0,434.79,232.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.27 228.88 351.04 233.49 338.05 185.91 372.28 181.3 385.27 228.88",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.59 229.11 349.35 233.72 336.36 186.13 370.6 181.53 383.59 229.11",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.19,206.11a3.75,3.75,0,0,0,4.07,2.84,3,3,0,0,0,2.59-3.74,3.72,3.72,0,0,0-4.06-2.84A3,3,0,0,0,355.19,206.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.7,195.94c-1.42,4-5.5,9.22-5.56,12.38a3.62,3.62,0,0,0,2.39,3.6s-3,1.87-2.54,4.74c.22,1.48,2.77,2.44,2.77,2.44a4.32,4.32,0,0,0-1.77,4.13c.43,2,2.92,2.68,2.92,2.68s-1.49,2.56-.4,4.48c2.21,3.89,19.83,2.1,21.89-4.67,1-3.15-3.32-2.48-3.32-2.48s5.92-2.45,5.64-6.09-5.78-2.43-5.78-2.43,5.72-2.43,5.05-6.18c-.7-3.9-6-1.75-6-1.75s3.65-3,2.48-5.8c-1.93-4.54-8.74,2.11-12.71,1.58L339,196.41Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.74,201.85c1-3.91-4.12-8.09-3.69-12,.59-5.24,6.88-.8,8.93,6.53l.58,6Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.29,226.07a0,0,0,0,0,0,.09,30.69,30.69,0,0,0,18-2.93c.17-.09.1-.41-.11-.35A63.16,63.16,0,0,1,335.29,226.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.68,219.14a.07.07,0,0,0,0,.13,28.77,28.77,0,0,0,19.47-4.42c.2-.13.24-.45,0-.31C349.14,216.9,339.4,219.05,333.68,219.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.32,206.37c-5.66,3.61-11.91,5-18.54,5.6-.09,0-.07.12,0,.14,3.32.61,7.51-.18,10.72-1.07a17.74,17.74,0,0,0,7.95-4.47C352.54,206.48,352.44,206.29,352.32,206.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.67,167.77s0,0,.05,0c.06,2.95.41,9.79,5,9a9.91,9.91,0,0,0,4.76-2.89,26.37,26.37,0,0,0,3.58-4.3,37.67,37.67,0,0,0,3.21-5.4c0-.08.16,0,.12.07-.94,1.89-1.7,3.83-2.82,5.64a22.84,22.84,0,0,1-3.85,4.75,9.9,9.9,0,0,1-5.09,2.85,3.74,3.74,0,0,1-4-2.48A16.47,16.47,0,0,1,395.67,167.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.2,173.65c3.34,0,8.33-6.59,9.61-11,.09-.3-1-3-2.07-6.46-.67-2.07-1.36-4.39-1.84-6.55l-12.84,6.3a35.53,35.53,0,0,1,3.16,8,5,5,0,0,1,.1.91s0,.09,0,.15C396.43,166.76,397,173.6,400.2,173.65Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.32,164.86s0,.09,0,.15a8.77,8.77,0,0,0,1.41-.23c7.81-1.92,7.53-11.94,7.28-14.73l-3.2,1.58-8.77,4.31a34.76,34.76,0,0,1,3.15,8A4.26,4.26,0,0,1,396.32,164.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,134.4c2.44,4.55,2.66,19-.16,22.81-4.09,5.51-12.16,7.56-17.19,2.33-4.87-5.07-4.83-23.93-1.55-27.52C390.91,126.72,401.38,127.7,405,134.4Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.31,146.2s.07.05.07.09c0,1,.14,2.09,1,2.4,0,0,0,.06,0,.05C393.33,148.61,393.14,147.12,393.31,146.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.16,145.17c1.56-.15,1.75,3,.3,3.13S392.84,145.29,394.16,145.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.77,146.35s-.07.05-.07.09c.09,1,0,2.1-.83,2.47a0,0,0,0,0,0,.06C388,148.75,388,147.25,387.77,146.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.84,145.38c-1.57,0-1.5,3.12,0,3.15S388.16,145.4,386.84,145.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.31,143.66c-.43-.09-.82-.23-1.24-.36a2.12,2.12,0,0,1-1.2-.6.68.68,0,0,1,.06-.82,1.65,1.65,0,0,1,1.65-.26,2.43,2.43,0,0,1,1.46,1A.72.72,0,0,1,395.31,143.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.66,144.68c.43-.1.81-.26,1.23-.4a2.13,2.13,0,0,0,1.18-.65.65.65,0,0,0-.09-.8,1.67,1.67,0,0,0-1.66-.22,2.41,2.41,0,0,0-1.42,1A.71.71,0,0,0,385.66,144.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.09,154.79c-.21.24-.43.57-.78.62a2.58,2.58,0,0,1-1.06-.18,0,0,0,0,0,0,.05,1.3,1.3,0,0,0,1.27.45,1,1,0,0,0,.71-.9C395.2,154.77,395.13,154.75,395.09,154.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.9,151.94a3.35,3.35,0,0,1-2.13,1.6,4.23,4.23,0,0,1-1.18.13,57.6,57.6,0,0,1-.45,0,.26.26,0,0,1-.21-.2h0a.38.38,0,0,1,0-.1h0v-.08c-.06-.75-.06-1.89-.06-1.89-.26.15-1.62.86-1.62.47a49.8,49.8,0,0,1,.69-10.11.09.09,0,0,1,.18,0c.12,3.12-.31,6.25-.23,9.39a5.76,5.76,0,0,1,1.53-.57c.11,0-.05,2.21,0,2.55v0a4.57,4.57,0,0,0,3.36-1.27C393.87,151.79,394,151.86,393.9,151.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.6,147s2.11-9.55.1-14c-.91-2-4.2-2.44-4.2-2.44a5,5,0,0,0-3.08-4.2c-3.24-1.48-9,1.06-9,1.06s-5.73-4.25-10.42-.2.95,9,.95,9-1,3.51,4.59,4.06c5.48.55,14.46-4.88,14.46-4.88a35.77,35.77,0,0,0,3.57,10A3.24,3.24,0,0,0,407.6,147Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.52,127.79a10,10,0,0,1,3.58-2,11,11,0,0,1,3.63-.63,6,6,0,0,1,5.49,2.92,4.23,4.23,0,0,1,.26,3.27s-.08,0-.06,0c.73-2-.76-4.18-2.5-5a9.1,9.1,0,0,0-6.46-.17,17.21,17.21,0,0,0-3.87,1.79A.07.07,0,0,1,390.52,127.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,131.15a4.88,4.88,0,0,1,2.21-4.06,8.37,8.37,0,0,1,5.21-1.57,10.52,10.52,0,0,1,5.27,1.68s0,.09,0,.07a9.27,9.27,0,0,0-9.48-.27,5.1,5.1,0,0,0-2.67,3.56,5,5,0,0,0,1.5,4,9.47,9.47,0,0,0,4.68,2.32s0,.06,0,.06a9.71,9.71,0,0,1-4.49-1.79A5.48,5.48,0,0,1,378,131.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.46,140.94a17.29,17.29,0,0,0,7.25-1.14,36,36,0,0,0,6.86-3.43c1.26-.8,2.49-1.65,3.71-2.52,0,0,.07,0,0,.06a38.58,38.58,0,0,1-6.59,4.78,19.42,19.42,0,0,1-7.13,2.36,17,17,0,0,1-4.15-.05A0,0,0,0,1,385.46,140.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.26,146.38s2.36-5.1,4.62-4.33,1,7.76-1.21,9.08a2.5,2.5,0,0,1-3.53-.73Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.48,144s.06.05,0,.07a6.26,6.26,0,0,0-2.51,4.45,1.37,1.37,0,0,1,2-.73c.05,0,0,.1,0,.1a1.53,1.53,0,0,0-1.57.82,7.62,7.62,0,0,0-.56,1.49c-.05.16-.34.13-.31-.06v0C405.06,148,406.2,144.67,408.48,144Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.25,164.78l4.58,7.55,8.35-11.89,3.39,2.81s-7.13,17.88-7.31,17.15L400.77,174l-4,5.64-1.62-12.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.62,173.63c-.2-2-.46-4.07-.57-6.11,0-.07.1-.12.13,0,.73,1.87,1.46,9.64,1.77,11.48l0,0c.16-.24,3.75-5,3.8-4.94.91,1,4.19,5.65,4.44,6.09,1.12-2.84,5.52-13.22,7-16a.07.07,0,0,1,.13,0c-.92,3-6.71,16.9-6.84,16.88a80.14,80.14,0,0,1-4.7-6.79c-.57,1-4.11,6.29-4.18,6A64.54,64.54,0,0,1,395.62,173.63Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.66,112.54a21.73,21.73,0,0,1-36.32,13.75l-10.88,1.59,5.44-9.4a21.74,21.74,0,1,1,41.76-5.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.66,112.54a21.85,21.85,0,0,1-4.39,11,23.44,23.44,0,0,1-2,2.26,25.07,25.07,0,0,1-2.29,2,22,22,0,0,1-11.1,4.31,20.31,20.31,0,0,1-3,.06,19.08,19.08,0,0,1-3-.31,22,22,0,0,1-10.75-5.31l.25.08-10.86,1.66-.79.12.4-.69,5.41-9.42,0,.37a22,22,0,0,1,1.34-19.38A22.38,22.38,0,0,1,423.66,92a22,22,0,0,1,34,20.53Zm0,0A21.49,21.49,0,0,0,433,89a21.45,21.45,0,0,0-9,3.54,22.55,22.55,0,0,0-6.51,7.1,21.59,21.59,0,0,0-2.76,9.2,21.89,21.89,0,0,0,1.53,9.47l.08.19-.1.18-5.48,9.39-.38-.58L421.29,126l.15,0,.11.1A21.47,21.47,0,0,0,432,131.42a19.48,19.48,0,0,0,3,.36,20.94,20.94,0,0,0,8.78-1.29,20.1,20.1,0,0,0,5.24-2.82,19.79,19.79,0,0,0,4.28-4.16A21.93,21.93,0,0,0,457.66,112.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.49 122.67 424.21 113.27 427.33 110.19 432.75 115.68 444.02 98.01 447.72 100.37 433.49 122.67",
    style: {
      fill: "#90CAF9"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCond);
export default __webpack_public_path__ + "static/media/cond.b672fe8c1a7458f215caee6d62842a38.svg";
export { ForwardRef as ReactComponent };